import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, createVNode as _createVNode, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-63507efa"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "StepCargoFTL" }
const _hoisted_2 = {
  key: 0,
  class: "flex justify-between"
}
const _hoisted_3 = { class: "StepCargoFTL__title" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-pen mr-2" }, null, -1))
const _hoisted_5 = {
  key: 1,
  class: "flex items-center justify-between"
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "StepCargoFTL__title" }, " Редактирование груза ", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-times mr-2" }, null, -1))
const _hoisted_8 = { class: "StepCargoFTL__grid" }
const _hoisted_9 = { class: "flex flex-col" }
const _hoisted_10 = { class: "StepCargoFTL__grid mt-2" }
const _hoisted_11 = { class: "StepCargoFTL__grid grid--triple mt-2" }
const _hoisted_12 = { class: "flex flex-col" }
const _hoisted_13 = { class: "StepCargoFTL__grid mt-2" }
const _hoisted_14 = { class: "flex flex-col" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "font-semibold text-gray-500 select-none" }, " Транспорт доставки ", -1))
const _hoisted_16 = { class: "mt-2" }
const _hoisted_17 = { class: "flex flex-col" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "font-semibold text-gray-500 select-none" }, " Способ оплаты за доставку ", -1))
const _hoisted_19 = { class: "flex items-center justify-end mt-3" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-check mr-2" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_the_button = _resolveComponent("the-button")!
  const _component_the_input = _resolveComponent("the-input")!
  const _component_the_textarea = _resolveComponent("the-textarea")!
  const _component_radio_group = _resolveComponent("radio-group")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!_ctx.isUpdate)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("p", _hoisted_3, _toDisplayString(_ctx.stepNumber) + ". Заполните характеристики груза", 1),
          (_ctx.isCompleted)
            ? (_openBlock(), _createBlock(_component_the_button, {
                key: 0,
                class: "primary small text mr-2",
                onClick: _ctx.emitUpdateCargo
              }, {
                default: _withCtx(() => [
                  _hoisted_4,
                  _createTextVNode(" Редактировать ")
                ]),
                _: 1
              }, 8, ["onClick"]))
            : _createCommentVNode("", true)
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _hoisted_6,
          _createVNode(_component_the_button, {
            class: "second text small",
            disabled: _ctx.disabled || _ctx.is_loading,
            onClick: _ctx.emitCancelUpdate
          }, {
            default: _withCtx(() => [
              _hoisted_7,
              _createTextVNode(" Отменить редактирование ")
            ]),
            _: 1
          }, 8, ["disabled", "onClick"])
        ])),
    (_ctx.opened && !_ctx.isCompleted)
      ? (_openBlock(), _createElementBlock("form", {
          key: 2,
          class: "mt-3",
          onSubmit: _cache[9] || (_cache[9] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.emitSubmit && _ctx.emitSubmit(...args)), ["prevent"]))
        }, [
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("div", _hoisted_10, [
                _createVNode(_component_the_input, {
                  placeholder: "Вес",
                  value: _ctx.state.weight,
                  "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.state.weight) = $event)),
                  "is-invalid": _ctx.state_form$.weight.$error,
                  "validation-errors": _ctx.state_form$.weight.$errors
                }, null, 8, ["value", "is-invalid", "validation-errors"]),
                _createVNode(_component_the_input, {
                  placeholder: "Количество мест",
                  value: _ctx.state.places,
                  "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.state.places) = $event)),
                  "is-invalid": _ctx.state_form$.places.$error,
                  "validation-errors": _ctx.state_form$.places.$errors
                }, null, 8, ["value", "is-invalid", "validation-errors"])
              ]),
              _createElementVNode("div", _hoisted_11, [
                _createVNode(_component_the_input, {
                  placeholder: "Длина",
                  value: _ctx.state.depth,
                  "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.state.depth) = $event)),
                  "is-invalid": _ctx.state_form$.depth.$error,
                  "validation-errors": _ctx.state_form$.depth.$errors
                }, null, 8, ["value", "is-invalid", "validation-errors"]),
                _createVNode(_component_the_input, {
                  placeholder: "Ширина",
                  value: _ctx.state.width,
                  "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.state.width) = $event)),
                  "is-invalid": _ctx.state_form$.width.$error,
                  "validation-errors": _ctx.state_form$.width.$errors
                }, null, 8, ["value", "is-invalid", "validation-errors"]),
                _createVNode(_component_the_input, {
                  placeholder: "Высота",
                  value: _ctx.state.height,
                  "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.state.height) = $event)),
                  "is-invalid": _ctx.state_form$.height.$error,
                  "validation-errors": _ctx.state_form$.height.$errors
                }, null, 8, ["value", "is-invalid", "validation-errors"])
              ]),
              _createVNode(_component_the_input, {
                placeholder: "Номер накладной заказчика",
                value: _ctx.state.dop_order_number,
                "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.state.dop_order_number) = $event))
              }, null, 8, ["value"]),
              _createVNode(_component_the_textarea, {
                class: "mt-2",
                autoheight: "",
                rows: 4,
                placeholder: "Особые условия",
                value: _ctx.state.special_conditions,
                "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.state.special_conditions) = $event))
              }, null, 8, ["value"])
            ]),
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("div", _hoisted_13, [
                _createElementVNode("div", _hoisted_14, [
                  _hoisted_15,
                  _createVNode(_component_radio_group, {
                    name: "shipment_type",
                    value: _ctx.state.shipment_type,
                    "onUpdate:value": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.state.shipment_type) = $event)),
                    options: _ctx.shipmentTypes,
                    class: "small mt-2"
                  }, null, 8, ["value", "options"])
                ])
              ]),
              _createElementVNode("div", _hoisted_16, [
                _createElementVNode("div", _hoisted_17, [
                  _hoisted_18,
                  _createVNode(_component_radio_group, {
                    name: "payment_method",
                    value: _ctx.state.payment_method,
                    "onUpdate:value": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.state.payment_method) = $event)),
                    options: _ctx.PAYMENT_METHOD_OPTIONS_INTRACITY,
                    class: "small mt-2"
                  }, null, 8, ["value", "options"])
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_19, [
            _createVNode(_component_the_button, {
              type: "submit",
              disabled: _ctx.disabled,
              class: "primary text small",
              loading: _ctx.is_loading
            }, {
              default: _withCtx(() => [
                _hoisted_20,
                _createTextVNode(" Подтвердить ")
              ]),
              _: 1
            }, 8, ["disabled", "loading"])
          ])
        ], 32))
      : _createCommentVNode("", true)
  ]))
}